const FIRST_NAMES = [
  "Alex",
  "Taylor",
  "Jordan",
  "Morgan",
  "Jamie",
  "Casey",
  "Logan",
  "Avery",
  "Cameron",
  "Reese",
  "Drew",
  "Parker",
  "Riley",
  "Quinn",
  "Hayden",
];

const LAST_NAMES = [
  "Smith",
  "Johnson",
  "Brown",
  "Walker",
  "Miller",
  "Wilson",
  "Clark",
  "Baker",
  "Hall",
  "Young",
  "Allen",
  "King",
  "Scott",
  "Hill",
  "Green",
];

const SAP_JUDGE_NAMES = [
  "Maria Rossi",
  "Luca Bianchi",
  "Giulia Conti",
  "Francesca Romano",
  "Marco Ferrari",
  "Alessandro Esposito",
  "Chiara Ricci",
  "Matteo Lombardi",
  "Sofia Moretti",
  "Andrea Russo",
  "Elena Ferrari",
  "Paolo Gallo",
  "Valentina Marino",
  "Davide Fontana",
  "Laura Greco",
  "Stefano Vitale",
  "Martina Rinaldi",
  "Fabio Colombo",
  "Isabella Santoro",
];

export const generateDemoUsers = ({
  count = 10,
  roleProfile = null,
  industryTemplate = null,
} = {}) => {
  return Array.from(
    { length: count },
    (_, index) => {

      const industryProfiles =
        industryTemplate?.userProfiles || [];

      const industryProfile =
        industryProfiles[index % Math.max(industryProfiles.length, 1)] || null;

      const industryNameParts =
        industryProfile?.displayName?.trim().split(/\s+/) || [];

      let firstName =
        industryNameParts[0] || FIRST_NAMES[index % FIRST_NAMES.length];

      let lastName =
        industryNameParts.slice(1).join(" ") ||
        LAST_NAMES[index % LAST_NAMES.length];

      let displayName =
        `${firstName} ${lastName}`;

      const profileCycle = industryProfiles.length
        ? Math.floor(index / industryProfiles.length)
        : 0;

      if (industryProfile && profileCycle > 0) {
        lastName = LAST_NAMES[(index + profileCycle) % LAST_NAMES.length];
        displayName = `${firstName} ${lastName}`;
      }

      let role =
        index === 0
          ? "Manager"
          : "Voter";

      let isJudge =
        false;

      let participantType =
        index === 0
          ? industryProfile?.participantType || "Event Manager"
          : industryTemplate?.voterLabel ||
            industryProfile?.participantType ||
            "Voter";

      //
      // Optional specialized demo roles
      //
      // Used by experiences like SAP AI Agents Challenge.
      //
      if (
        roleProfile?.judgeCount &&
        index > 0 &&
        index <= roleProfile.judgeCount
      ) {
        role = "Judge";

        isJudge = true;

        participantType = "Judge";

        displayName =
          SAP_JUDGE_NAMES[index - 1];

        const parts =
          displayName.split(" ");

        firstName =
          parts[0];

        lastName =
          parts.slice(1).join(" ");
      }

      return {
        demoSeed: true,

        firstName,

        lastName,

        displayName:
          displayName,

        email:
          `demo.${industryTemplate?.key || "event"}.${index + 1}@letsgovote.app`,

        role,
        isJudge,
        participantType,
        industryKey:
          industryTemplate?.key || "other",
      };
    }
  );
};
